import { useState } from 'react';
import Form from '../Form';
import Title from 'src/components/common/Title';
import PropertyList from '../PropertyList';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import Loading from 'src/components/common/Loading/Loading';
import { getEntitiesRewards } from 'src/apis/programsAssignment';

const SearchByUsers = () => {
    const token = useSelector((state: RootState) => state.User.token);
    const [loadingList, setLoadingList] = useState(false);
    const [list, setList] = useState([]);
    const [error, setError] = useState('');

    const handleSearch = (data) => {
        setLoadingList(true);
        const values = `user_ids=${data.list}&from_xml=${data.from_xml}`;
        getEntitiesRewards({ token, values })
            .then((res) => {
                setList(res.reward_properties || []);
                setLoadingList(false);
                setError(!res?.reward_properties || res?.reward_properties?.length < 1 ? '* No hay propiedades' : '');
            })
            .catch((e) => {
                console.error('Error búsqueda por usuario', e);
                setError('Error en la búsqueda, verifique los datos');
                setLoadingList(false);
            });
    };

    const resetValues = () => {
        setList([]);
        setError('');
    };
    return (
        <>
            <Title>Búsqueda por usuarios</Title>
            <Form type="users" handleSearch={handleSearch} loadingList={loadingList} resetValues={resetValues} />
            {loadingList ? (
                <div style={{ height: '250px' }}>
                    <Loading height="80%" />
                </div>
            ) : (
                ''
            )}
            {list?.length > 0 && <PropertyList list={list} setList={setList} />}
            <Title>{error}</Title>
        </>
    );
};

export default SearchByUsers;
